import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/infopages.scss";

function Cookies() {
  return (
    <div className="privacy">
      <Header />
      <main id="maincontent" className="page-main">
        <div className="page-title-wrapper">
          <h1 className="page-title"><span className="base">Cookie Policy</span></h1>
        </div>
        <div className="columns"><div className="column main">
          <p>Last updated: 8 September 2026</p>
          <p>This policy explains how hetcratehub uses cookies and similar browser storage on hetcratehub.today.</p>

          <h4>What cookies are</h4>
          <p>Cookies are small data files stored by your browser. Similar technologies include local storage and pixels. They can remember a cart, keep a session secure, or help a site understand how it is used.</p>

          <h4>Cookies we may use</h4>
          <ul>
            <li><strong>Strictly necessary:</strong> required for core features such as navigation, security, checkout, and cart state.</li>
            <li><strong>Preferences:</strong> remember choices such as display or consent settings.</li>
            <li><strong>Analytics:</strong> help us understand aggregate site performance and improve pages when analytics are enabled.</li>
            <li><strong>Marketing:</strong> measure campaigns or personalise promotions only where used and where required consent has been obtained.</li>
          </ul>

          <h4>Your choices</h4>
          <p>You can control non-essential cookies through any consent controls we provide and through your browser settings. Blocking strictly necessary storage may prevent the cart or checkout from working correctly.</p>

          <h4>Retention and third parties</h4>
          <p>Cookie duration depends on its purpose. Session cookies expire when the browser closes; persistent cookies remain until their stated expiry or deletion. Service providers may set cookies when they provide payment, security, hosting, or measurement functions, subject to their own notices.</p>

          <h4>Contact</h4>
          <p>For cookie questions, email <a href="mailto:group@hetcratehub.today">group@hetcratehub.today</a>.</p>
        </div></div>
      </main>
      <Footer />
    </div>
  );
}

export default Cookies;
